export const POP_CONFIRM_ALERT = 'Are you sure you want to cancel this job configuration ?';
export const YES_DECISION = 'Yes';
export const NO_DECISION = 'No';
export const REQUEST_BUTTON = 'Request';
export const CANCEL_BUTTON = 'Cancel';
export const SELECTED_UPLOAD_PROJECT = 'Please select upload layer';
export const PACKAGE_RELEASING = 'Package release is processing';

export const POP_CONFIRM_ALERT_BACK = 'Are you sure you want to go back? This action will discard the changes. ';
export const POP_CONFIRM_ALERT_CANCEL = 'Are you sure you want to cancel all the changes?';
export const POP_CONFIRM_ALERT_CANCEL_UPLOAD = 'Are you sure you want to cancel this upload?';
export const POP_CONFIRM_REQUEST_ENTITLEMENT_1 = "You're going to request FPGA FARM CLOUD";
export const POP_CONFIRM_NO_QSLOTS = 'YOU DO NOT HAVE QSLOT PERMISSIONS FOR THIS PROJECT, PLEASE TALK WITH QSLOT OWNER';
export const POP_CONFIRM_QSLOT_OWNERS_LIST = 'List of Qslot Owners -';

export const RADIO_BUTTON_PERMISSIONS = {
	USER: { value: 'USER', description: 'USER: Executes jobs only.' },
	DEVELOPER: { value: 'DEVELOPER', description: 'DEVELOPER: Executes jobs and uploads ingredients.' },
};
